import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BlogLeftArrow, BlogRightArrow } from "../common/Icon";
import { ChatavirsityContentData } from "../common/Helper";
import { useStateProvider } from "../common/StateProvider";
import { useNavigate } from "react-router-dom";

const ChataSlider = () => {
  const navigate = useNavigate();
  const { setCardData } = useStateProvider();
  const [activeArrow, setActiveArrow] = useState("right");
  // const [setSliderCardData] = useState("");
  // const [SetShowSliderData] = useState(false);
  const readMoreHandler = (value, index) => {
    // SetShowSliderData(true);
    // setSliderCardData(value);
    setCardData(value);
    localStorage.setItem("items", JSON.stringify(value));
    navigate(`/chatavirsity-description/${index}`);
  };
  // Function to handle left arrow click
  const handleLeftArrow = () => {
    chataSlides.current.slickPrev();
    setActiveArrow("left");
  };

  // Function to handle right arrow click
  const handleRightArrow = () => {
    chataSlides.current.slickNext();
    setActiveArrow("right");
  };
  const chataSlides = {
    dots: false,
    nextArrow: ".left-arrow",
    prevArrow: ".right-arrow",
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
       {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="relative">
        <h5 className="text-xl xl:text-2xl font-bold text-black">
          Explore more Chatavirsity
        </h5>
        <Slider {...chataSlides} ref={chataSlides}>
          {ChatavirsityContentData.map((obj, index) => (
            <div className="px-2">
              <a href="#">
                <div
                  key={index}
                  className="w-full overflow-hidden object-cover border border-[#f2f2f2] rounded-[20px] mt-3 md:mt-5 xl:mt-10">
                  <img
                    className="w-full"
                    width={310}
                    height={201}
                    loading="lazy"
                    src={obj.chataimg1}
                    alt="all-blogs-img"
                  />
                  <div className="p-3 xl:p-[18px]">
                    <h3 className="xl:pt-0.5 font-bold text-sm xl:text-base text-black">
                      {obj.chataheading}
                    </h3>
                    <p className="text-xs xl:text-sm font-normal text-black mt-3 md:mt-5">
                      {obj.chatapara}
                    </p>
                    <button
                      onClick={() => readMoreHandler(obj, index)}
                      className="py-[7px] px-7 rounded-3xl mt-2.5 text-primary bg-[#f3f3fe] text-xs font-normal hover:bg-primary hover:text-white transition-all ease-in-out duration-300">
                      {obj.chatabtn}
                    </button>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </Slider>
        <div>
          <button
            aria-label="Slider Arrow"
            onClick={handleLeftArrow}
            className={`common-arrow left-arrow w-full absolute -right-[75%] 3xl:-right-[85%] top-0 left ${
              activeArrow === "left" ? "opacity-1" : "opacity-50"
            }`}>
            <BlogLeftArrow />
          </button>
          <button
            aria-label="Slider Arrow"
            onClick={handleRightArrow}
            className={`common-arrow right-arrow w-full absolute -right-[83%] 3xl:-right-[90%] top-0 left  ${
              activeArrow === "right" ? "opacity-1" : "opacity-50"
            }`}>
            <BlogRightArrow />
          </button>
        </div>
      </div>
    </>
  );
};

export default ChataSlider;
